<script setup lang="ts">
import DataProcessingPolicyDocument from '~/shared-kernel/presentation/legal/DataProcessingPolicyDocument.vue'
import { useDataProcessingPolicy } from '~/shared-kernel/presentation/legal/useDataProcessingPolicy'

const { t } = useI18n()
const { open } = useDataProcessingPolicy()
const policyView = ref<InstanceType<typeof DataProcessingPolicyDocument> | null>(null)

watch(open, value => { if (value) policyView.value?.reset() })

function blockDocumentShortcuts(event: KeyboardEvent) {
  if (open.value && (event.ctrlKey || event.metaKey) && ['p', 's', 'c', 'x'].includes(event.key.toLowerCase())) {
    event.preventDefault()
  }
}

onMounted(() => window.addEventListener('keydown', blockDocumentShortcuts, true))
onBeforeUnmount(() => window.removeEventListener('keydown', blockDocumentShortcuts, true))
</script>

<template>
  <UModal v-model:open="open" :title="t('dataProcessingPolicy.title')" :description="t('dataProcessingPolicy.description')"
    :ui="{ content: 'w-[calc(100%-1rem)] max-w-5xl max-h-[90dvh]', body: 'min-h-0 overflow-auto' }">
    <template #body>
      <DataProcessingPolicyDocument ref="policyView" />
    </template>
  </UModal>
</template>
